/* iceberg-ui */
import { Button, Flex, Text } from '@auviknetworks/iceberg-ui';

/* MUI */
import { useTheme } from '@mui/material/styles';

/* Shared */
import { Route } from 'application/Shared/Helpers';

/* React */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router';

import { MotionWrapper } from './OnboardingGraphic/OnboardingGraphic';
import { DeployAgentInsteadGraphic } from './OnboardingGraphic/internal/DeployAgentInsteadGraphic';

export const QuickScanInstallAgentInsteadStep = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { partnerId } = useParams();
    const basePartnerRoute = Route.buildBasePartnerRoute({ partnerId });
    return (
        <Flex
            alignItems="center"
            data-testid="onboardingQuickScanInstallAgentInsteadStep"
            flexDirection="column"
            mt={4}
            mx="4%"
        >
            <Text
                fontSize={4}
                color={theme.palette.onboarding.titleTextColor}
                mt={3}
                textAlign="center"
            >
                {t('Onboarding.quickScanInstallAgentInsteadStep.subtitle')}
            </Text>
            <Flex
                data-testid="onboardingWhyInstallAgentStepImg"
                justifyContent="center"
                width="100%"
                my={5}
            >
                <MotionWrapper key="onboardingWhyInstallAgentStepMW">
                    <DeployAgentInsteadGraphic />
                </MotionWrapper>
            </Flex>
            <Flex flexDirection="column">
                <Text
                    color={theme.palette.onboarding.titleTextColor}
                    fontSize={4}
                    my={4}
                    dangerouslySetInnerHTML={{
                        __html: t(
                            'Onboarding.quickScanInstallAgentInsteadStep.info'
                        )
                    }}
                />
                <Link
                    to={`${basePartnerRoute}/onboarding/deployAgent/select`}
                    style={{
                        alignSelf: 'center',
                        marginBottom: '16px',
                        marginTop: '16px'
                    }}
                    data-trackid="onboardingQuickScanInstallAgentInsteadStep_routeTo"
                >
                    <Button
                        data-testid="onboardingQuickScanInstallAgentInsteadStep"
                        data-trackid="onboardingQuickScanInstallAgentInsteadStep"
                    >
                        {t(
                            'Onboarding.quickScanInstallAgentInsteadStep.button'
                        )}
                    </Button>
                </Link>
            </Flex>
        </Flex>
    );
};
